export const CUSTOMER_SETTINGS_REDUCER = 'customerSettings'
